import { AfterViewInit, Component, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LoginFormComponent } from '../../components/login-form/login-form.component';

export interface dataStructure {
  id: number;
  username: string;
  email: string;
  picture: string;
  system: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: true,
  imports: [LoginFormComponent]
})
export class LoginComponent implements AfterViewInit {
  deviceInfo: any;

  @Output() userInfo: dataStructure = {
    id: 1,
    username: '',
    email: '',
    picture: '../../../assets/images/icons/user.png',
    system: ''
  };

  constructor(
    private authService: MsalService,
    private route: Router,
    private deviceService: DeviceDetectorService
  ) {}

  ngAfterViewInit(): void {
    this.hideOverlay();
    this.titleAnimation();
  }

  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.userInfo.system = this.deviceInfo.os;
  }

  hideOverlay() {
    const body = document.querySelectorAll('body');
    const overlay = document.querySelectorAll('.modal-backdrop.fade.in');

    setTimeout(() => {
      if (body[0].classList.contains('modal-open')) {
        body[0].classList.remove('modal-open');
        overlay[0].remove();
      }
    }, 110);
  }

  titleAnimation() {
    var titleContainer = document.getElementById('titleLogin');
    var titleText = 'Welcome to Performance Portal';
    var typer: any;

    var char = titleText.split('').reverse();
    typer = setInterval(function () {
      if (!char.length) return clearInterval(typer);
      var next = char.pop();
      if (titleContainer) {
        titleContainer.innerHTML += next;
      }
    }, 150);
  }
}
